// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Lc","subtitle":"Mc","contentWrap":"Nc","imgWrap":"Oc","heading":"Pc","copy":"Qc"};